import { Box, Collapse, Divider, Flex, Heading, Spacer, useDisclosure } from '@chakra-ui/react'
import React from 'react'
import { FaAngleDown, FaAngleUp } from 'react-icons/fa'

const CollapsibleCard = ({
  title,
  leftElement,
  rightElement,
  hasBorder = true,
  defaultIsOpen = false,
  children,
  width = '100%',
  headerElement,
}) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: defaultIsOpen })

  if (headerElement) {
    return (
      <Box
        borderWidth={hasBorder ? '1px' : '0'}
        rounded="lg"
        shadow={hasBorder ? '1px 1px 3px rgba(0,0,0,0.3)' : ''}
        w={width}
        p={3}
        h="100%"
        bg="white"
        maxW={'100%'}
      >
        <Flex onClick={onToggle} _hover={{ cursor: 'pointer' }} alignItems={'center'} gap={2} py="2">
          {headerElement}
          {isOpen ? <FaAngleUp /> : <FaAngleDown />}
        </Flex>
        <Divider />

        <Collapse in={isOpen} animateOpacity overflow="visible">
          <Box mt="4">{children}</Box>
        </Collapse>
      </Box>
    )
  }
  return (
    <Box
      borderWidth={hasBorder ? '1px' : '0'}
      rounded="lg"
      shadow={hasBorder ? '1px 1px 3px rgba(0,0,0,0.3)' : ''}
      w={width}
      p={3}
      h="100%"
      bg="white"
      maxW={'100%'}
    >
      <Flex onClick={onToggle} _hover={{ cursor: 'pointer' }} alignItems={'center'} gap={2} py="2">
        <Flex alignItems={'center'} gap="2">
          <Heading size="md">{title}</Heading>
          {leftElement}
        </Flex>
        <Spacer />
        <Flex alignItems={'center'} gap="2">
          {rightElement}

          {isOpen ? <FaAngleUp /> : <FaAngleDown />}
        </Flex>
      </Flex>
      <Divider />

      <Collapse in={isOpen} animateOpacity overflow="visible">
        <Box mt="4">{children}</Box>
      </Collapse>
    </Box>
  )
}

export default CollapsibleCard
